import React from "react";
import { Paths } from "../constants/UrlConstants";
import { getPhone } from "../helpers/ContentStateHelper";

const MyProfileContactPreferences = {
  HeadingForSME: "How would you like to receive your plan and claims documents?",
  HeadingForIndividual: {
    // Any:
    //   "How would you like to receive your policy documents and claims information?",
    // HOL:
    //   "How would you like to receive your policy documents and claims information?"
    Any:
      "How would you like to receive your plan and claims documents?",
    HOL:
      "How would you like to receive your plan and claims documents?"
  },
  PrintPreferenceCopyForIndividual: {
    Any: (props, params) => (
      <React.Fragment>
        <p>
          If you choose to receive these online only, we'll email you whenever there's 
          something new for you to view online. Even when your document preference is set 
          to online, you can still call us on {getPhone(props)} at any time if you want to receive 
          a paper copy of any of your documents.
        </p>
      </React.Fragment>
    ),
    HOL: (props, params) => (
      <React.Fragment>
        <p>
          If you choose to receive these online only, we'll email you whenever there's 
          something new for you to view online. Even when your document preference is set 
          to online, you can still call us on {getPhone(props)} at any time if you want to receive 
          a paper copy of any of your documents.
        </p>
      </React.Fragment>
    )
  },

  PrintPreferenceCopyForSME: {
    Any: (props, params) => (
      <React.Fragment>
        <p>
          If you choose to receive these online only, we'll email you whenever there's 
          something new for you to view online. Even when your document preference is set 
          to online, you can still call us on {getPhone(props)} at any time if you want to receive 
          a paper copy of any of your documents.
        </p>
      </React.Fragment>
    ),
    HOL: (props, params) => (
      <React.Fragment>
        <p>
          If you choose to receive these online only, we'll email you whenever there's 
          something new for you to view online. Even when your document preference is set 
          to online, you can still call us on {getPhone(props)} at any time if you want to receive 
          a paper copy of any of your documents.
        </p>
      </React.Fragment>
    )
  },
  GDPRDescription: {
    HOL: (
      <React.Fragment>
        {/* <p>
          Please answer the question below so that AXA, which Health-on-Line is
          part of, can keep you up to date on our latest products and service in
          a way that suits you.
        </p>
        <p>
          Your membership comes with a number of additional discounted health
          and leisure benefits including gym membership and health assessments.
          Please tick the boxes below to choose how you would like to receive
          updates from AXA about these and other products and services,
          promotions, special offers and news.
        </p> */}
        <p>
          We'd also like to tell you about any member offers plus other products, services 
          and news in the future. We need your permission to send you these promotional 
          communications so please select all the ways you are happy to receive these  from the 
          list below:
        </p>
      </React.Fragment>
    ),
    MOL: (
      // <p>
      //   Your membership comes with a number of additional discounted health and
      //   leisure benefits including gym membership and health assessments. Please
      //   tick the boxes below to choose how you would like to receive updates
      //   from AXA about these and other products and services, promotions,
      //   special offers and news.
      // </p>
      <p>
        We'd also like to tell you about any member offers plus other products, services
        and news in the future. We need your permission to send you these promotional 
        communications so please select all the ways you are happy to receive these  from the 
        list below:
    </p>
    )
  },
  Label: "I'd like to receive my information online.",
  UpdateButton: "Save Changes",
  ContinueButton: "Continue",
  AccountText :"Need to change account?",
  AccountTextUpper :"NEED TO CHANGE ACCOUNT?",
  MarketingSection:"My marketing preferences",
  ContactSection:{
    Heading:"How can we contact you about your plan's services?",
    Subheading:(
    <React.Fragment>
      <p>
        We'd like to keep you informed about your plan's features and services like our 
        online GP service. We can send you information in various ways so that you're ready 
        to use these services should you need to. Just let us know which of the options 
        listed below we can use to keep you informed? Choose as many as you like. Texts are 
        only used for selected messages so you'll need to choose another option to receive 
        all your communications. 
      </p>
      </React.Fragment>
    ),
    HomeHeading:"Keeping in touch about your plan",
    HomeSubheading:(
      <React.Fragment>
        <p>
        How would you like us to contact you about your plan and how it works?  
        Please select all ways that you’re happy to hear from us from the list below. 
        </p>
        </React.Fragment>),
  },
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help",
    Faq: [
      {
        Question:
          "What will happen when I update my communication preferences?",
        Answer: {
          Any: (
            <React.Fragment>
              <p>
                When you update your preferences, all future membership
                documents and claims information will be sent to you by your
                chosen preference.
              </p>
              {/* <p>
                When you choose online, there will be some occasions when we
                send you a paper copy too, as we'll also need to send you
                something else relevant to the claim - e.g. a cheque.
              </p> */}
            </React.Fragment>
          )
        }
      },
      {
        Question: "Why I am still receiving documents by post?",
        Answer: {
          Any: (
            <p>
              Although you have chosen your preference as online, there are
              occasions when we need to send you other information - e.g. a
              cheque.
            </p>
          )
        }
      },
      {
        Question: "Can I receive my documents by post as well as online?",
        Answer: {
          Any: (
            <p>
              Yes, if you choose the post option all your documents will be
              posted to you, but the information will also be available online.
            </p>
          )
        }
      },
      {
        Question: "Can you send me information in alternative ways ?",
        Answer: {
          Any: (
            <p>
              We can provide communications in various ways to help you access the 
              communications we send you. Just go to the 'My communication needs' tab 
              and select the option  you need.  You should start to receive future 
              communications in the way you've chosen. If you don't, let us know and 
              we can resend it. 
            </p>
          )
        }
      },
      {
        Question: "Are my contact options the same as marketing preferences?",
        Answer: {
          Any: (
            <p>
              When you confirm your contact preferences you are letting us know how we 
              can contact you about your existing plan so that we can help you use all its 
              features. These contact options are not the same as marketing preferences which 
              would allow us to tell you about other products and services.
            </p>
          )
        }
      }
    ]
  },
  Errors: {
    PreferenceUpdateFailed:
      "There was an error processing your update, please try again later.",
    GetMasterDataFailed: "Sorry, something went wrong. Please try again.",
    PersonNotFoundError:"Contact preference option is not available for this member.",
  },
  SaveContactPreferenceSuccess:"Thank you, your contact options have been updated.",
  SaveContactPreferenceError:"Sorry, something went wrong. Please try again.",
  SaveContactPreferenceErrorOnboard:"Sorry, something went wrong. Please press 'Skip' and we'll ask you next time.",
  noSelectionContactPreferenceError:"Please choose at least one way that we can contact you",
  NoChangesMessage:"Thanks you. You have chosen to not change your options.",
  PreferenceUpdateSucceeded: "Thank you, your preference has been updated.",
  ContactPreferencesUpdateSucceeded:
    "Thank you for letting us know how you'd like us to contact you. It's all done, but if you've asked us to stop any of our updates, we may not be able to stop any that are already on their way to you.",
    noSelectionCommSupportNeedsError: "Please select at least one to proceed further.",
};

export default MyProfileContactPreferences;
